import { Component, OnInit, OnDestroy, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subject, Subscription } from "rxjs";
import { ApiDataService } from "src/app/shared/services/api.service";
import { Location } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { takeUntil } from 'rxjs/operators';
import { StorageService } from "src/app/shared/services/storage.service";
import { Lesson } from "../../../lessons/models/lesson";
import { StudentSession } from "src/app/shared/models/student-session";
import { enagagementTabs, errorMessages } from "../../constants/passage-constants";

@Component({
    selector: "final-review",
    templateUrl: "./final-review.component.html",
    styleUrls: ["./final-review.component.css"],
    standalone: false
})

export class FinalReview implements OnInit, OnDestroy {
  subscription: Subscription;
  loading = true;
  lessons: Lesson[] = [];
  student: any;
  tutorTipModal=false;
  tutorTips="";
  sessionEngageDetails=[]
  sessionData: StudentSession;
  lessonName: string = '';
  isSavingLoader: boolean = false

  private ngUnsubscribe = new Subject <void>();
  constructor(
    private apiService: ApiDataService,
    private toastrService: ToastrService,
    public _location: Location,
  ) {}

  ngOnInit() {
    this.sessionData = StorageService.getSessionData();
    this.getSessionDetails()
    this.getTutorTips()
  }

  @Output() changeTab = new EventEmitter<number>();
  
  goToTab(index: number) {
    this.changeTab.emit(index);
  }

  onSubmit() {
    this.updateProgress()
  }

  updateProgress() {
    this.isSavingLoader = true;
    const engagementReviewTabKey = enagagementTabs.engagementReview
    const progressData = {
      current_page: engagementReviewTabKey,
      lesson: this.sessionData["lesson"],
      volunteer: this.sessionData["volunteer"],
      student: this.sessionData["student"],
      curriculum_name: this.sessionData["curriculum_name"] || null,
      session_completed: 1,
    };

    this.apiService.updateSessionEngagement(progressData).subscribe(
      (res) => {
        if (res) {
          this.goToTab(engagementReviewTabKey)
          StorageService.setSessionCurrentPage(engagementReviewTabKey);
        }
        this.isSavingLoader = false
      },
      (err) => {
        this.toastrService.error(errorMessages.UPDATE_PROGRESS_FAILED);
        this.isSavingLoader = false
      }
    );
  }

  getSessionDetails() { 
    try {
      const lessonStudentIds = { 
        lessonId: this.sessionData["lesson"], 
        studentId: this.sessionData["student"]
      };

      this.apiService
      .getSessionDetails(lessonStudentIds)
      .subscribe((res) => {
        if (res) {
          if (res?.data?.length) {
            this.sessionEngageDetails = res.data?.map((item) => {
              item.words_learnt = item?.first_read_words?.filter(
                (word) => !item?.second_read_words?.includes(word)
              );
              return item;
            });
          }
          this.loading = false
        }
      });
    } catch (error) {
      this.loading = false
      console.error("Error fetching tutor tip:", error);
    }
  }

  getTutorTips() { 
    try {
      this.apiService
      .getLessonTutorTips(this.sessionData["lesson"])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.tutorTips = res.tutor_tips;
          this.lessonName = res?.lesson_plan_name || '';
        }
      });
    } catch (error) {
      console.error("Error fetching tutor tip:", error);
    }
  }

  tutorTipModalOpen(value:boolean) {
    this.tutorTipModal=value
  }

  onBackClick () {
    const postEngagementTabKey = enagagementTabs.postEngagement
    this.goToTab(postEngagementTabKey)
    StorageService.setSessionCurrentPage(postEngagementTabKey);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription?.unsubscribe();
    }
  }
}
